import React from "react";

import { useAppSelector } from "../../reducers";
import { NavButton } from "../components/NavButton";
import { Step } from "../constants";
import { ISelections } from "../models.interfaces";

import styles from "./MattressMatchNav.module.scss";

const SELECTION_DATA: {
    [key in Step]?: keyof ISelections;
} = {
    [Step.SLEEP]: "selectedSleepPosition",
    [Step.HEIGHT]: "selectedHeight",
    [Step.WEIGHT]: "selectedWeight",
    [Step.COOLING]: "selectedCoolness",
    [Step.BUDGET]: "selectedBudget",
};

export const MattressMatchNav = () => {
    const { currentScreen } = useAppSelector((state) => state.mattressmatch.ui);
    const step = Object.values(Step)[currentScreen];

    return (
        <nav className={styles.navContainer}>
            <span className={styles.gradient}></span>
            <div className={styles.nav}>
                <NavButton
                    key={currentScreen}
                    selectionData={SELECTION_DATA[step] || "selectedSize"}
                    step={step}
                />
            </div>
        </nav>
    );
};
